import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ContentBox from "src/components/ContentBox/ContentBox";
import Footer from "src/components/footer/footer";
import Header from "src/components/header/header";
import { textStyle } from "src/styles/textstyle";
import { AccordionWrapper } from "./MainPage/Components/StillUnsure";
import { Box, ThemeProvider } from "@mui/material";
import theme from "src/styles/mainstyle";
import { membershipPoliciesandStandards } from "src/media/texts/termsAndCondition/membershipPoliciesandStandards";
import { userGuidelines } from "src/media/texts/termsAndCondition/userGuidelines";
import { liabilityAndLegalClaims } from "src/media/texts/termsAndCondition/liabilityAndLegalClaims";
import { insurancePolicy } from "src/media/texts/termsAndCondition/insurancePolicy";
import { disclaimersandLimitationsofResponsibility } from "src/media/texts/termsAndCondition/disclaimersandLimitationsofResponsibility";
import { intellectualPropertyandCopyrightNotices } from "src/media/texts/termsAndCondition/intellectualPropertyandCopyrightNotices";
import { thirdPartyWebsiteLinks } from "src/media/texts/termsAndCondition/thirdPartyWebsiteLinks";
import { warrantyLimitationsandExclusions } from "src/media/texts/termsAndCondition/warrantyLimitationsandExclusions";
import { appropriateUseAndAntiSpamMeasures } from "src/media/texts/termsAndCondition/appropriateUseandAntiSpamMeasures"
import { privacyAndConfidentiality } from "src/media/texts/termsAndCondition/privacyAndConfidentiality";

export default function TermsAndConditions() {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <Box sx={{ pt: 15 }} />
      <ContentBox title="Terms and conditions" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Membership, Policies and Standards
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {membershipPoliciesandStandards.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              User Guidelines for the Platform
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {userGuidelines.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Liability and Legal Claims
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {liabilityAndLegalClaims.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Insurance Policies
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {insurancePolicy.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Disclaimers and Limitations of Responsibility
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {disclaimersandLimitationsofResponsibility.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Intellectual Property and Copyright Notices
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {intellectualPropertyandCopyrightNotices.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Appropriate Use and Anti-Spam Measures
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {appropriateUseAndAntiSpamMeasures.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Third-Party Website Links
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {thirdPartyWebsiteLinks.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Warranty Limitations and Exclusions
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {warrantyLimitationsandExclusions.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Disclaimer of Warranties
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {disclaimersandLimitationsofResponsibility.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <ContentBox title="" id={"good-advice-1"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
            >
              Privacy and Confidentiality
            </Typography>
            {/* </Grid> */}
            <Grid item xs={12} md={8}>
              {privacyAndConfidentiality.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={index + 1 + ". " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <Footer />
    </ThemeProvider>
  );
}
